import {
  changeWizardValuesToUseNewGroups, getConflictingWizardSteps, getNextWizardSteps,
  switchCartItemsToNewWizardGroups
} from "./lookWizardFunctions2";
import store from "../../../../../store";


/**
 * @param forNewCartItems {cartItemInterface[]} - cart items to check for conflicts
 * @returns {object}
 * */
export const checkWizardConflictingSteps = (forNewCartItems = []) => {
  const {quotesState, wizardState, fabricatorState} = store.getState();
  const {wizardActiveItem, wizardSelectedValues} = wizardState;
  const quoteIndex = quotesState.activeQuoteIndex;
  if (!fabricatorState.settings.checkout || !wizardActiveItem || !forNewCartItems.length) {
    return []
  }
  const currentStep = +Object.keys(wizardSelectedValues)[0];
  let newWizValues = wizardSelectedValues;
  const commonObject = {wizardActiveItem, quoteIndex, wizardSelectedValues};
  let newWizardSteps = getNextWizardSteps(wizardActiveItem, currentStep, newWizValues);

  // console.log("newWizardSteps", newWizardSteps);
  // here we replace cartItems to match new selections! to prevent conflicting
  let {updatedWizardValues, shouldReassignValues} = changeWizardValuesToUseNewGroups(newWizValues, newWizardSteps);
  if (shouldReassignValues) {
    newWizValues = updatedWizardValues;
    // create new steps according to new values
    newWizardSteps = getNextWizardSteps(wizardActiveItem, currentStep, newWizValues);
    // console.log("newWizardSteps2!", newWizardSteps);
  }
  // here we replace cartItems to match new selections! to prevent conflicting
  let {newCartItems, shouldReassign} = switchCartItemsToNewWizardGroups(
    newWizardSteps,
    commonObject,
    forNewCartItems,
  );
  // if (shouldReassign) {
  //   dispatch(changeAllCartItems([...newCartItems]))
  // }

  const wizardConflictingSteps = getConflictingWizardSteps(
    newWizValues,
    commonObject,
    newCartItems,
    newWizardSteps,
    true,
  );

  return {
    shouldReassign,
    newCartItems,
    wizardConflictingSteps,
  }
}

// const {shouldReassign, newCartItems, wizardConflictingSteps,} = checkWizardConflictingSteps(newCartItems);
